import * as React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Redirect, Route, useLocation } from 'react-router-dom';
import { useOpenReportingLocation } from 'src/hooks';
import * as Types from '../../types';

interface Props {
  children: React.ReactNode;
}

const isAuthenticated = (session: string | null | undefined): boolean => {
  if (!session) {
    return false;
  }

  return true;
};

const isAuthorised = (user: Types.User | null): boolean => {
  if (user === null) {
    return false;
  }

  if (
    user?.systemPermissions?.includes('NAV_CASES') ||
    user?.systemPermissions?.includes('NAV_USERS') ||
    user?.systemPermissions?.includes('NAV_DISCLOSURES')
  ) {
    return true;
  }

  return false;
};

const isExpired = (session: string | null | undefined): boolean => {
  if (session === null) {
    return true;
  }

  return false;
};

const isSameOrganisation = (usersOrgSlug: string, orgSlug: string) => {
  if (!usersOrgSlug || !orgSlug) return true;
  return usersOrgSlug.toLowerCase() === orgSlug.toLowerCase();
};

export const AuthenticatedRoute: React.FC<Props> = (props) => {
  const state = useSelector(
    (state: Types.State) => ({
      currentUser: state.globalUsers.currentUser,
      session: state.globalUsers.session,
      openReportingSession: state.openReporting?.openReportingReducer?.session,
      userOrgSlug:
        state.openReporting?.openReportingReducer?.publicReporterAccount?.user
          ?.organisation?.slug ?? '',
    }),
    shallowEqual,
  );

  const { orgSlug, isOpenReporting, basePath } = useOpenReportingLocation();

  const location = useLocation();
  const redirectToNext = `${location.pathname}${location.search}`;

  if (isOpenReporting) {
    if (
      !isAuthenticated(state.openReportingSession) ||
      isExpired(state.openReportingSession) ||
      !isSameOrganisation(state.userOrgSlug, orgSlug)
    ) {
      return <Redirect to={basePath} />;
    }
  } else {
    if (!isAuthenticated(state.session) || !isAuthorised(state.currentUser)) {
      return (
        <Redirect
          to={{
            pathname: '/login',
            state: { redirectToNext },
          }}
        />
      );
    }
    if (isExpired(state.session)) {
      return <Redirect to="/expired" />;
    }
  }

  return <Route>{props.children}</Route>;
};
